var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CFooter',{attrs:{"fixed":false}},[_c('div',{staticClass:"lasDividerbottom"}),_c('div',{staticClass:"container-fluid rodapeClaimer"},[_vm._v(" © 2022 LAS Brasil. Todos os direitos reservados | Site desenvolvido por Yellow Lamp ")])])}
var staticRenderFns = []

export { render, staticRenderFns }